import Api from "@/api/apiAxios";
export default {
	queryPage: (pageNo:Number,pageSize:Number,params:Object) => Api.postRequest(`/transOrder/queryPage/${pageNo}/${pageSize}`,params),
	transOrder:{
		export:(params:object)=> Api.postRequest(`/transOrder/export`, params), 
	},
};